import { render, staticRenderFns } from "./PrepareProvideFoodCeremony.vue?vue&type=template&id=774e0a6d"
import script from "./PrepareProvideFoodCeremony.vue?vue&type=script&lang=js"
export * from "./PrepareProvideFoodCeremony.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports